import axiosInstance from 'helpers/axiosInstance';
import { getBusinessId } from 'helpers/query';
import { ISubscriptions } from 'modules/ProductManagement';
import { ICheckoutRedirect } from 'modules/ProductManagement/reducers/type';
import { AxiosResponse } from 'axios';
import { EActionType } from 'modules/ProductManagement/type';

export const getProductList = () => {
    return axiosInstance.get<ISubscriptions>('/api/subscriptions', {
        params: {
            businessId: getBusinessId(),
        },
    });
};

export const getCheckoutRedirectUrl = (
    action: EActionType,
    redirectUrl: string,
): Promise<AxiosResponse<ICheckoutRedirect>> =>
    axiosInstance.get<ICheckoutRedirect>('/api/checkout-redirect', {
        params: {
            businessId: getBusinessId(),
            actionId: action,
            redirectUrl,
        },
    });
